import styled from 'styled-components';
import { colors } from '../../common/ui/globalColors';

export const StyledBuildingPaymentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 80px;
    color: ${colors.textColors.black};
    position: relative;
    font-family: var(--bllink-font-secondary);

    .mc-logo {
        max-height: 100px;
        max-width: 200px;
    }
    
    .page-title {
        font-family: var(--bllink-font-headers);
        font-size: 64px;
        margin-bottom: 5px;
        line-height: 67px;
        font-weight: 400;

        .building-address {
            color: var(--bllink-purple);
        }
    }

    .choose-action-subheader {
        font-size: 18px;
        margin-bottom: 70px;
        margin-top: 25px;
        text-align: center;
        max-width: 550px;
    }

    .credit-card-and-actions-block {
        position: relative;
        background-color: rgba(255, 255, 255, 0.8);
        min-width: 770px;
        padding: 60px;
        border-radius: 20px;
        box-shadow: 0px 8px 30px rgba(67, 57, 126, 0.1);
        
        .credit-card-img {
            position: absolute;
            z-index: -1;
            top: -90px;
            left: -90px;
        }
        
        .actions-block {
            display: flex;
            flex-direction: column;
            gap: 15px;
            align-items: center;
        }

        .app-btn {
            font-family: var(--bllink-font-headers);
            font-weight: 400;
            font-size: 18px;
            width: 370px;
            height: 60px;
            display: flex;
            gap: 18px;
            position: relative;
            padding-left: ${({ ltr }) => ltr ? '' : '50px'};
            padding-right: ${({ ltr }) => ltr ? '50px' : ''};

            .icon {
                position: absolute;
                left: ${({ ltr }) => ltr ? '10px' : ''};
                right: ${({ ltr }) => ltr ? '' : '10px'};
            }

            .arrow {
                transform: ${({ ltr }) => ltr ? 'rotate(180deg)' : 'rotate(0deg)'};
                position: absolute;
                right: ${({ ltr }) => ltr ? '10px' : ''};
                left: ${({ ltr }) => ltr ? '' : '10px'};
            }
        }

        .app-btn.btn-bordered {
            border: 2px solid var(--bllink-purple);
            padding-left: ${({ ltr }) => ltr ? '50px' : ''};
            padding-right: ${({ ltr }) => ltr ? '' : '50px'};
        }
    }

    // manager details page
    .managers {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: start;
        
        .manager-details {
            font-size: 16px;
            display: flex;
            flex-direction: column;
            gap: 26px;
            margin-bottom: 60px;

           .details-header {
                margin-bottom: 14px;
                opacity: 0.7;
            }

            .manager-value {
                font-size: 18px;
                font-weight: 700;
            }          
        }

        .app-btn {
            width: 270px;
        }
    }

    // choose payment method page
    .choose-method {
        .methods {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: ${({ numOfMethods }) => numOfMethods < 3 ? '1fr' : numOfMethods < 5 ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)'};
            column-gap: 30px;
            row-gap: 16px;
            margin-bottom: 57px;
            width: 100%;
            font-weight: 700;
            font-family: var(--bllink-font-primary);

            .method-item {
                border: 1px solid #DCDCE2;
                border-radius: 10px;
                display: flex;
                gap: 13px;
                align-items: center;
                padding: 15px;
                cursor: pointer;
                position: relative;
                font-size: 18px;
                height: 58px;

                .method-label {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    line-height: 100%;

                    .credit-card-text {
                        font-weight: 700;
                        font-size: 10px;
                        color: #836CFF;
                        margin-bottom: -4px;
                    }
                }

                .radio-btn-outer {
                    width: 20px;
                    height: 20px;
                    border: 1px solid #DCDCE2;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    top: 10px;
                    right: ${({ ltr }) => ltr ? '10px' : ''};
                    left: ${({ ltr }) => ltr ? '' : '10px'};

                    .radio-btn-inner {
                        width: 8px;
                        height: 8px;
                        background: #DCDCE2;
                        border-radius: 50%;
                    }
                }
            }

            .method-item.selected {
                border: 1px solid #8764FF;

                .radio-btn-outer {
                    border: 1px solid #8764FF;

                    .radio-btn-inner {
                        background: linear-gradient(87.88deg, #6B92FF 0%, #8764FF 100%);
                    }
                }
            }

            .method-item.disabled {
                pointer-events: none;
                background: #dedede;
            }
        }

        .app-btn {
            height: 60px !important;
        }
    }

    // direct transfer
        .amount-to-transfer {
            font-weight: 700;
            font-size: 18px;
            line-height: 29px;
            color: ${colors.textColors.black};
            font-family: var(--bllink-font-primary);
            margin-bottom: 19px;
            display: flex;
            gap: 31px;
        }

        .direct-transfer {
            padding: 0 20px;
            display: flex;
            flex-direction: column;
            gap: 32px;

            .credit-card-and-actions-block {
                width: 100%;
            }

            .credit-card-and-actions-block.transfer {
                display: flex;
                flex-direction: column;
                gap: 8px;
                padding: 25px 12px 18px 30px;
                font-family: var(--bllink-font-secondary);
                font-weight: 700;

                .verification-code {
                    line-height: 26px;
                    width: 100%;

                    .verification-note {
                        font-weight: 400;
                    }
                }

                .cart-id-wrapper {
                    background: #F3F1FF;
                    border-radius: 10px;
                    font-family: var(--bllink-font-primary);
                    padding: 13px 16px;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    cursor: pointer;

                    .copy {
                        text-decoration: underline;
                        color: #6E74FF;
                    }
                }

                .confirmation-sent {
                    width: 100%;
                }
            }

            .credit-card-and-actions-block.account {
                padding: 19px 24px 42px 36px;
                font-family: var(--bllink-font-secondary);
                align-items: start;
                gap: 17px;

                .details-title {
                    font-weight: 700;
                    margin-bottom: -11px;
                }
            }
        }

    @media screen and (max-width: 768px) {
        margin: 70px 0 150px;

        .page-title {
            font-size: 32px;
            line-height: 34px;
            margin: 33px 0 10px;
            padding: 0 5px;
        }

        .choose-action-subheader {
            font-size: 16px;
            margin: 10px 0 73px;
            font-family: var(--bllink-font-primary);
        }

        .choose-action-subheader.payment-method {
            margin: 10px 0 40px;
        }

        .credit-card-and-actions-block {
            width: 90%;
            min-width: unset;
            padding: 50px 20px;
            font-family: var(--bllink-font-primary);
            
            .credit-card-img {
                width: 150px;
                top: -60px;
                left: 0;
                right: 0;
                margin: auto;
            }
            
            .app-btn {
                width: 300px;
                height: 54px;
                display: flex;
                gap: 18px;
                font-size: 20px;
            }          
        }

        // manager details page
        .manager-subheader {
            margin-bottom: 50px;
        }

        .managers {
            .manager-details {
                width: 100%;
            }

            .app-btn {
                width: 100%;
            }
        }

        // choose payment method page
        .choose-method {
            padding: 50px 21px;

            .methods {
                grid-template-columns: 1fr;
                grid-template-rows: ${({ numOfMethods }) => `repeat(${numOfMethods}, 1fr)`};
                gap: 16px;
                margin-bottom: 40px;
            }
        }

        .direct-transfer {
            width: 100%;
        }
        
    }
`
